import { prefixObjectValues as pre } from '../utils';

const prefix = 'confirmation-dialog';

const dialog = pre(
  {
    title: 'titleText,',
    message: 'messageText',
    confirmBtn: 'confirmBtn',
    cancelBtn: 'cancelBtn',
  },
  prefix
);

export default {
  ...dialog,
};
